import React from 'react';

export const legalRichTextValues = {
  strong: (...chunks) => <strong>{chunks}</strong>,
};
